import styled from "styled-components";
import { tombac } from "../../shared/tombac";
import { propStyling } from "../../shared";
export const ModalWindow = styled.div.attrs(() => ({
  className: "TombacModalWindow"
})).withConfig({
  displayName: "ModalWindow"
})(["background-color:", ";border-radius:", ";box-shadow:", " ", ";", ""], tombac.color.white, tombac.unit(20), tombac.unit(0, 2, 5, 0), tombac.alpha("neutral", 24), propStyling);
//# sourceMappingURL=ModalWindow.js.map